import { render, staticRenderFns } from "./shopType.vue?vue&type=template&id=eb52a08e&"
import script from "./shopType.vue?vue&type=script&lang=js&"
export * from "./shopType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports